import React, { Component, PropTypes } from 'react';
import styles from '../SeenBlock.scss';


export default class SeenBlockItem extends Component {
  render() {
    const {photo, name, description} = this.props.item;
    return (
      <div className={ styles.seenBlockItem }>
        <a href="#">
          <img src={photo} alt=""/>
        </a>
        <div className={ styles.seenBlockItemTextBlock }>
          <a href="#">
            <p className={ styles.itemName }>
              { name }
            </p></a>
          <p className={ styles.itemDescription }>
            { description }
          </p>
        </div>
      </div>
    );
  }
}



SeenBlockItem.propTypes = {
};



/** WEBPACK FOOTER **
 ** ./src/components/SeenBlock/elements/SeenBlockItem.jsx
 **/